/**
 * Report card hover — toggles .is-hovered on the wrapper of any report-card.
 *
 * Why JS instead of pure CSS :hover:
 *   The :hover state is recalculated by the browser during DOM reflows of the
 *   card subtree. In products-grid-table we have JS that does appendChild on
 *   cards to reorder them (syncCardsToCurrentPage), MutationObserver triggers
 *   from the tbody, and inline Chart.js renders. Each of these can briefly
 *   detach/reattach the card from the layout, causing the CSS :hover state to
 *   flicker even though the cursor never moved.
 *
 *   mouseenter/mouseleave events fire only when the cursor crosses the
 *   boundary of the listened element. They are immune to internal reflows.
 *
 * Event delegation on document so dynamically added/reordered cards are
 * automatically covered without re-binding listeners.
 */
(function () {
  'use strict';

  var WRAPPER_SELECTOR = '.product-card-item, .rk-funnel-card-item';

  /* mouseenter/mouseleave do not bubble, so we use mouseover/mouseout
     and check that the related target is outside the same wrapper. This
     gives mouseenter/mouseleave-equivalent behavior with delegation. */
  document.addEventListener('mouseover', function (e) {
    var wrapper = e.target.closest(WRAPPER_SELECTOR);
    if (!wrapper) return;
    var related = e.relatedTarget;
    if (related && wrapper.contains(related)) return; // still inside, ignore
    wrapper.classList.add('is-hovered');
  });

  document.addEventListener('mouseout', function (e) {
    var wrapper = e.target.closest(WRAPPER_SELECTOR);
    if (!wrapper) return;
    var related = e.relatedTarget;
    if (related && wrapper.contains(related)) return; // moved to a child, still hovered
    wrapper.classList.remove('is-hovered');
  });
})();
